import { Provider } from "react-redux";
import { RouterProvider } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { router } from "./router";
import { store } from "./redux/store";
import ErrorComponent from "./layouts/Error";
import signUplogo from "./assets/images/logo/Trellis_Logo.png";
import NotificationProvider from "./notifications/NotificationProvider";
import { ReactQueryProvider } from "./config/react-query";
import { PostHogProvider } from "posthog-js/react";
import { posthog } from "./config/posthog";
import { configureAxios } from "./config/axios";
import { AbilityContextProvider } from "./config/casl/casl";
import { Suspense } from "react";
import i18n from "./i18n";
import { I18nextProvider, Trans, useTranslation } from "react-i18next";

declare global {
  interface Window {
    _hsq?: [string, unknown][];
  }
}

configureAxios();

const MaintenancePage = () => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-12 text-center" style={{ margin: "4em" }}>
          <img className="" style={{ width: "50%" }} src={signUplogo} alt={t(($) => $.common.tos.Trellis)} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-center">
          <h1 style={{ fontSize: "2em" }}>
            {t(($) => $.common.maintenance["The portal is currently down for maintenance"])}
          </h1>
          <p>
            <Trans
              t={t}
              i18nKey={($) =>
                $.common.maintenance[
                  "If you require immediate assistance please reach out to <supportLink>support</supportLink>."
                ]
              }
              components={{ supportLink: <a href="mailto:support@gotrellis.com" /> }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  if (import.meta.env.VITE_MAINTENANCE === "true") {
    return (
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={null}>
          <MaintenancePage />
        </Suspense>
      </I18nextProvider>
    );
  }

  return (
    <PostHogProvider client={posthog}>
      <Provider store={store}>
        <Sentry.ErrorBoundary fallback={<ErrorComponent />}>
          <ReactQueryProvider>
            <I18nextProvider i18n={i18n}>
              <Suspense fallback={null}>
                <NotificationProvider>
                  <AbilityContextProvider>
                    <RouterProvider router={router} />
                  </AbilityContextProvider>
                </NotificationProvider>
              </Suspense>
            </I18nextProvider>
          </ReactQueryProvider>
        </Sentry.ErrorBoundary>
      </Provider>
    </PostHogProvider>
  );
};

export default Sentry.withProfiler(App);
